(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-assign"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.add-to-cart').forEach(button => {
    button.addEventListener('click', function() {
      const productId = this.dataset.productId;
      const quantity = 1;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: productId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        // You can add cart drawer opening or redirect to cart page here
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error:', error);
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
